import { XcoreCore } from "XcoreCore";

export const invalidateCache = (core: XcoreCore) => core.fetch("/api/cache/invalidate");
